import { z } from 'zod';

export const ImportTypeSchema = z.enum(['Locations','Contacts','Permits','PermitAttachments','CrmRequests','CrmAttachments','CrmComments','CodeCases','CodeActions','CodeAttachments','CodeViolations','CodeAddresses']);

export type ImportTypeType = `${z.infer<typeof ImportTypeSchema>}`

export default ImportTypeSchema;
